// src/App.js
import React, { useState, useEffect } from "react";
import "./App.css";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyDnh4CPfM0pc10QftI5ZFqoZbAHUEh50kE",
  authDomain: "ifonitiselladas-be3be.firebaseapp.com",
  projectId: "ifonitiselladas-be3be",
  storageBucket: "ifonitiselladas-be3be.appspot.com",
  messagingSenderId: "785377585977",
  appId: "1:785377585977:web:7ef581bb112c71eaac56e8",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const ADMIN_PASSWORD = "00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";

function App() {
  const [articles, setArticles] = useState([]);
  const [newArticle, setNewArticle] = useState({
    title: "",
    date: "",
    excerpt: "",
    image: "",
    content: "",
  });
  const [isAdmin, setIsAdmin] = useState(false);
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState(null);

  // 🔹 Fetch άρθρων από Firestore
  const fetchArticles = async () => {
    const querySnapshot = await getDocs(collection(db, "articles"));
    const data = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setArticles(data);
  };

  useEffect(() => {
    fetchArticles();
  }, []);

  // 🔹 Login / Logout
  const handleLogin = () => {
    if (password === ADMIN_PASSWORD) {
      setIsAdmin(true);
      setShowPwd(false);
    } else {
      alert("Λάθος κωδικός!");
    }
    setPassword("");
  };

  const handleLogout = () => {
    setIsAdmin(false);
  };

  // 🔹 Προσθήκη άρθρου
  const addArticle = async () => {
    if (!newArticle.title || !newArticle.content) return alert("Συμπλήρωσε όλα τα πεδία!");
    await addDoc(collection(db, "articles"), newArticle);
    setNewArticle({ title: "", date: "", excerpt: "", image: "", content: "" });
    fetchArticles();
  };

  // 🔹 Διαγραφή άρθρου
  const deleteArticle = async (id) => {
    if (window.confirm("Είσαι σίγουρος ότι θέλεις να διαγράψεις αυτό το άρθρο;")) {
      await deleteDoc(doc(db, "articles", id));
      fetchArticles();
    }
  };

  return (
    <div className="App">
      {/* Top Bar */}
      <div className="top-bar">
        <div className="top-left">
          <img src="/main.logo.jpeg" alt="Logo" className="small-logo" />
          <button className="home-btn" onClick={() => setSelectedArticle(null)}>Αρχική</button>
        </div>
        <div className="top-right">
          {!isAdmin ? (
            showPwd ? (
              <>
                <input
                  type="password"
                  placeholder="Κωδικός admin"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button className="login-btn" onClick={handleLogin}>Σύνδεση</button>
                <button onClick={() => setShowPwd(false)}>Άκυρο</button>
              </>
            ) : (
              <button className="login-btn" onClick={() => setShowPwd(true)}>Σύνδεση</button>
            )
          ) : (
            <button className="login-btn" onClick={handleLogout}>Αποσύνδεση</button>
          )}
        </div>
      </div>

      {/* Header */}
      <header className="site-header">
        <img src="/main.logo.jpeg" alt="main logo" className="main-logo" />
        <h1 className="site-title">Η Φωνή της Ελλάδας</h1>
      </header>

      {/* Admin: Προσθήκη άρθρου */}
      {isAdmin && (
        <section className="add-article">
          <h2>Δημιουργία Νέου Άρθρου</h2>
          <input
            placeholder="Τίτλος"
            value={newArticle.title}
            onChange={(e) => setNewArticle({ ...newArticle, title: e.target.value })}
          />
          <input
            placeholder="Ημερομηνία"
            value={newArticle.date}
            onChange={(e) => setNewArticle({ ...newArticle, date: e.target.value })}
          />
          <input
            placeholder="Περιγραφή"
            value={newArticle.excerpt}
            onChange={(e) => setNewArticle({ ...newArticle, excerpt: e.target.value })}
          />
          <input
            placeholder="Εικόνα (URL ή /όνομα)"
            value={newArticle.image}
            onChange={(e) => setNewArticle({ ...newArticle, image: e.target.value })}
          />
          <textarea
            placeholder="Περιεχόμενο"
            value={newArticle.content}
            onChange={(e) => setNewArticle({ ...newArticle, content: e.target.value })}
          />
          <button className="btn add" onClick={addArticle}>Προσθήκη Άρθρου</button>
        </section>
      )}

      {/* Άρθρα */}
      <main className="articles-container">
        {articles.length === 0 ? (
          <p className="no-articles">Δεν υπάρχουν άρθρα ακόμη.</p>
        ) : (
          articles.map((a) => (
            <article key={a.id} className="article-card" onClick={() => setSelectedArticle(a)}>
              <img src={a.image} alt={a.title} />
              <h3>{a.title}</h3>
              <p>{a.excerpt}</p>
              {isAdmin && (
                <button
                  className="btn danger small"
                  onClick={(e) => {
                    e.stopPropagation();
                    deleteArticle(a.id);
                  }}
                >
                  Διαγραφή
                </button>
              )}
            </article>
          ))
        )}
      </main>

      {/* Άρθρο μεμονωμένο */}
      {selectedArticle && (
        <div className="article-page">
          <button className="btn back" onClick={() => setSelectedArticle(null)}>⬅ Επιστροφή</button>
          <h2>{selectedArticle.title}</h2>
          <img src={selectedArticle.image} alt={selectedArticle.title} className="article-img" />
          <div className="article-content">{selectedArticle.content}</div>
        </div>
      )}

      {/* Footer */}
      <footer className="footer">
        <p>
          Η Φωνή της Ελλάδας αποτελεί την ηχηρή Ελληνική πατριωτική φωνή όλων των νοήμωνων Ελλήνων.
          Σε αυτήν την ιστοσελίδα θα αναρτώνται άρθρα που θα ασκούν κριτική στα όσα συμβαίνουν γύρω μας.
          
        </p>
        <p className="email">📧 Επικοινωνία: <a href="mailto:iphonitiselladas@gmail.com">iphonitiselladas@gmail.com</a></p>
        <p className="copy">© {new Date().getFullYear()} Η Φωνή της Ελλάδας</p>
      </footer>
    </div>
  );
}

export default App;
